import register from 'preact-custom-element'

import ProductPriceBlockController from './productPriceBlockController/ProductPriceBlockController'

register(
  ProductPriceBlockController,
  'product-price-block-controller',
  [
    'articles',
    'article-erp-item-number',
    'channel-id',
    'bom',
    'await-bom-before-pricehelper-request',
    'category',
    'sub-category',
    'weeks-until-delivery',
    'struct-sku',
  ],
  { shadow: false }
)
